import { createSlice } from "@reduxjs/toolkit";
import { RootGlobalState } from "../stores/global";

type ToastBg = [
  "Primary",
  "Secondary",
  "Success",
  "Danger",
  "Warning",
  "Info",
  "Light",
  "Dark"
][number];

export interface IToast {
  header: string;
  body: string;
  bg: ToastBg;
  timestamp: number;
  duration: number;
}

export interface ToastState {
  toasts: IToast[];
  disable: boolean;
}

const initialState: ToastState = { toasts: [], disable: true };

export const GlobalSlice = createSlice({
  name: "ToastState",
  initialState,
  reducers: {
    addToast(state: ToastState, action: { payload: IToast }) {
      state.toasts.push(action.payload);
    },
    clearToast(state: ToastState) {
      state.toasts.splice(0, state.toasts.length);
    },
    removeToast(state: ToastState, action: { payload: number }) {
      const index = state.toasts.findIndex(
        (t) => t.timestamp === action.payload
      );
      if (index >= 0) {
        state.toasts.splice(index, 1);
      }
    },
    setDisableToasting(state: ToastState, action: { payload: boolean }) {
      state.disable = action.payload;
    },
  },
});
export const { addToast, setDisableToasting, removeToast, clearToast } =
  GlobalSlice.actions;

// export const selectUserId = (state: ProlificExperiments) => state.user?._id;
export const getToasts = (state: RootGlobalState) => state.toasts.toasts;
export const getToastsDisabled = (state: RootGlobalState) =>
  state.toasts.disable;

export default GlobalSlice.reducer;
